import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getTipoDispositivo = async() => {
    const respuesta = await PrivateInterceptor(`IT/TipoDispositivo/`, 'GET')
    return respuesta;
}

export const getTipoDispositivoToVideo = async() => {
    const respuesta = await PrivateInterceptor(`IT/TipoDispositivo/ToVideo`, 'GET')
    return respuesta;
}

export const getTipoDispositivoToTelefonia = async() => {
    const respuesta = await PrivateInterceptor(`IT/TipoDispositivo/ToTelefonia`, 'GET')
    return respuesta;
}

export const guardarTipoDispositivo = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/TipoDispositivo/AgregarTipoDispositivo", "POST",{datos});
    return respuesta;
};
  
  export const editarTipoDispositivo = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/TipoDispositivo/EditarTipoDispositivo", "POST",{datos});
    return respuesta;
};